export default __webpack_public_path__ + "static/media/news23111402.086e0945.jpg";